//login 
export const URL_LOGIN = "https://node-migra-code-portfolio-umber.vercel.app/login";

//portfolio
export const URL_PORTFOLIO =
  "https://node-migra-code-portfolio-umber.vercel.app/student";

// students
export const URL_STUDENTS =
  "https://node-migra-code-portfolio-umber.vercel.app/students";
export const QUERY_TO_FETCH_NEXT_PAGE_STUDENTS = `offset=`;
export const QUERY_FILTER_STUDENTS = `filterBy`;
export const QUERY_FILTER_STUDENTS_BY_A_TO_Z = `a-z`;
export const QUERY_FILTER_STUDENTS_BY_Z_TO_A = `z-a`;
// export const QUERY_FILTER_STUDENTS_BY_NEW_TO_OLD_GRADUATION_DATE = `newToOldGraduationDate`;
// export const QUERY_FILTER_STUDENTS_BY_OLD_TO_NEW_GRADUATION_DATE = `oldToNewGraduationDate`;
export const URL_FILTER_STUDENT_BY_NAME = `${URL_STUDENTS}?studentFullName=`;
export const NUMBER_OF_PROJECTS_DISPLAYED = 2;

// projects
export const URL_PROJECTS =
  "https://node-migra-code-portfolio-umber.vercel.app/projects";
export const QUERY_TO_FETCH_NEXT_PAGE_PROJECTS = `nextpage=`;
export const QUERY_FILTER_PROJECTS = `orderby`;
export const QUERY_FILTER_PROJECTS_BY_A_TO_Z = `a-z`;
export const QUERY_FILTER_PROJECTS_BY_Z_TO_A = `z-a`;
export const QUERY_FILTER_PROJECTS_BY_OLDEST_TO_NEWEST = `date-a-z`;
export const QUERY_FILTER_PROJECTS_BY_NEWEST_TO_OLDEST = `date-z-a`;
export const URL_NEW_PROJECT =
  "https://node-migra-code-portfolio-umber.vercel.app/projects";

// Official MigraCode website
export const LINK_OFFICIAL_MIGRACODE_WEBSITE =
  "https://migracode.openculturalcenter.org/";

// contact
export const URL_POST_CONTACT =
  "https://node-migra-code-portfolio-umber.vercel.app/contact";
  